function getAudioFormat() {
  const hasAudioContext = window.AudioContext || window.webkitAudioContext;
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  if (iOS || !hasAudioContext) {
    return null;
  }

  try {
    const a = document.createElement('audio');
    const mp3Support = (typeof a.canPlayType === 'function' && a.canPlayType('audio/mpeg') !== '');
    return mp3Support ? 'mp3' : 'ogg';
  } catch (e) {
    return null;
  }
}

export default getAudioFormat();



/** WEBPACK FOOTER **
 ** ./src/lib/audioFormat.js
 **/